/**
 * HakedisDetayTablo.jsx
 *
 * Danışman CRM Faz 2 — hakediş detay tablosu (ortak bileşen).
 *
 * Backend (routes/prim.py /danisman/hakedis, /admin/hakedis-ozet):
 *   - kademe_detay doluysa (kademeli kurala düşen günler) o kural için TEK
 *     kademe kırılımı gösterilir (aralık/oran/dilim tutarı/hakediş) — GÜN
 *     bazlı `detay` YERİNE bu render edilir.
 *   - kademe_detay boşsa legacy `detay` (gün bazlı satır satır oran/hakediş)
 *     gösterilir.
 *   - `pencere_disi_tahsilat` > 0 ise hakedişe DAHİL OLMAYAN ayrı bir satır
 *     olarak eklenir (bkz. HakedisPenceresiRozeti — aynı kohort pencere
 *     modeli).
 */
import { fmtMoney, fmtPercent } from '../../utils/money';

function fmtAralik(esik, ustSinir, tr) {
  if (ustSinir == null) return `${fmtMoney(esik)}+`;
  return `${fmtMoney(esik)} – ${fmtMoney(ustSinir)}`;
}

export default function HakedisDetayTablo({ kademeDetay, detay, pencereDisiTahsilat, tr, lang }) {
  const hasKademe = Array.isArray(kademeDetay) && kademeDetay.length > 0;
  const hasDetay = Array.isArray(detay) && detay.length > 0;
  if (!hasKademe && !hasDetay && !(pencereDisiTahsilat > 0)) return null;

  return (
    <div className="mt-2 overflow-x-auto">
      {hasKademe ? (
        <table className="w-full text-xs">
          <thead>
            <tr style={{ color: 'var(--crm-muted-2)' }} className="text-left">
              <th className="pb-1 font-bold">{tr('Kademe Aralığı', 'Tier Range')}</th>
              <th className="pb-1 font-bold text-right">{tr('Oran', 'Rate')}</th>
              <th className="pb-1 font-bold text-right">{tr('Dilim Tutarı', 'Slice Amount')}</th>
              <th className="pb-1 font-bold text-right">{tr('Hakediş', 'Earnings')}</th>
            </tr>
          </thead>
          <tbody>
            {kademeDetay.map((d, i) => (
              <tr key={i} className="border-t" style={{ borderColor: 'var(--crm-card-border)' }}>
                <td className="py-1" style={{ color: 'var(--crm-navy-text)' }}>{fmtAralik(d.esik_tutar, d.ust_sinir, tr)}</td>
                <td className="py-1 text-right font-bold" style={{ color: 'var(--crm-gold-dark)' }}>{fmtPercent(d.oran, lang)}</td>
                <td className="py-1 text-right" style={{ color: 'var(--crm-muted)' }}>{fmtMoney(d.tutar)}</td>
                <td className="py-1 text-right font-bold" style={{ color: 'var(--crm-navy-text)' }}>{fmtMoney(d.hakedis)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : hasDetay ? (
        <table className="w-full text-xs">
          <thead>
            <tr style={{ color: 'var(--crm-muted-2)' }} className="text-left">
              <th className="pb-1 font-bold">{tr('Gün', 'Day')}</th>
              <th className="pb-1 font-bold text-right">{tr('Tahsilat', 'Collection')}</th>
              <th className="pb-1 font-bold text-right">{tr('Oran', 'Rate')}</th>
              <th className="pb-1 font-bold text-right">{tr('Hakediş', 'Earnings')}</th>
            </tr>
          </thead>
          <tbody>
            {detay.map((d, i) => (
              <tr key={i} className="border-t" style={{ borderColor: 'var(--crm-card-border)' }}>
                <td className="py-1" style={{ color: 'var(--crm-navy-text)' }}>{d.gun}</td>
                <td className="py-1 text-right" style={{ color: 'var(--crm-muted)' }}>{fmtMoney(d.tahsilat)}</td>
                <td className="py-1 text-right font-bold" style={{ color: d.oran_yuzde == null ? 'var(--crm-danger)' : 'var(--crm-gold-dark)' }}>
                  {d.oran_yuzde == null ? tr('Kural yok', 'No rule') : fmtPercent(d.oran_yuzde, lang)}
                </td>
                <td className="py-1 text-right font-bold" style={{ color: 'var(--crm-navy-text)' }}>{d.hakedis == null ? '-' : fmtMoney(d.hakedis)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}

      {pencereDisiTahsilat > 0 && (
        <p
          className="mt-2 text-[11px] font-semibold px-2 py-1.5 rounded-lg"
          style={{ backgroundColor: 'rgba(160,61,44,0.06)', color: 'var(--crm-danger)' }}
        >
          {tr('Pencere dışı tahsilat (hakedişe dahil değil)', 'Outside-window collections (not included in earnings)')}: {fmtMoney(pencereDisiTahsilat)}
        </p>
      )}
    </div>
  );
}
